// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBqMOMuXdf3NT8wxBMBdB2okzvGgmaMqFU',
    authDomain: 'matriculaucn.firebaseapp.com',
    databaseURL:
      'https://matriculaucn.firebaseio.com/student/hnERvcuOAwfl6lNagVc9',
    projectId: 'matriculaucn',
    storageBucket: 'matriculaucn.appspot.com',
    messagingSenderId: '593166298582',
    appId: '1:593166298582:web:9c14010e77122fd3ca8877',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
